import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../GlobalContext";
import { deletingPunch } from "../../../utils/Timecard";

const ConfirmationDeletePunch = ({
  row,
  open,
  setOpen,
  reloading,
  punch,
  setPunch,
}) => {
  const { t } = useTranslation("timecard.form.confirm_delete_punch");

  const { handlerAlert } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const closing = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        closing();
      }}
    >
      <DialogTitle>
        <Typography variant="body3">
          {t("confirm_delete_punch.title")}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        {t("confirm_delete_punch.message", {
          name: row?.path ? row?.path[0] : undefined,
          time: moment(punch?.date_time, "YYYY-MM-DD hh:mm").format(
            "YYYY-MM-DD hh:mm",
          ),
        })}
      </DialogContent>

      <DialogActions>
        <LoadingButton
          variant="contained"
          disableElevation
          onClick={() => {
            deletingPunch(
              setLoading,
              punch.date,
              `${punch.time}:00`,
              row.person_number,
              reloading,
              handlerAlert,
            );

            setPunch(null);
            setOpen(false);
          }}
          loading={loading}
          disabled={loading}
        >
          {t("confirm_delete_punch.buttons.delete")}
        </LoadingButton>

        <Button
          variant="contained"
          disableElevation
          color="error"
          onClick={() => {
            closing();
          }}
          sx={{ mr: 1.5 }}
        >
          {t("confirm_delete_punch.buttons.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { ConfirmationDeletePunch };
